import { useAppActions } from 'reducers/slices/mortgageSurveySlice';
import { useSelector } from 'react-redux';

export default () => {
  const {
    changeSurveyFieldValue,
    submitCurrentQuestion,
    changeCurrentStepValidity,
    discardSteps,
    discardSurveyValues,
    setInitialSurveyValues,
    incrementPastStepsCount,
    setSurveyPassed,
    setSurveyChanged,
    setManuallyChangedSurveyValues,
    setSelectedMortageSurveyFlow,
  } = useAppActions();

  const {
    surveyValues,
    lastStepId,
    isValidCurrentStep,
    pastStepsCount,
    surveyPassed,
    surveyChanged,
    manuallySettedInitialSurveyValues,
    selectedMortgageSurveyFlow,
  } = useSelector(state => state.mortgageSurveySlice);

  return {
    changeSurveyFieldValue,
    setManuallyChangedSurveyValues,
    selectedMortgageSurveyFlow,
    setSelectedMortageSurveyFlow,
    discardSteps,
    setInitialSurveyValues,
    manuallySettedInitialSurveyValues,
    discardSurveyValues,
    incrementPastStepsCount,
    changeCurrentStepValidity,
    submitCurrentQuestion,
    lastStepId,
    pastStepsCount,
    isValidCurrentStep,
    surveyValues,
    surveyPassed,
    setSurveyPassed,
    surveyChanged,
    setSurveyChanged,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useMortgageSurvey.js